export async function writeToClipboard(clipboardData, externalClipboardWrite) {
    if (externalClipboardWrite) {
        return writeToClipboardExternal(clipboardData, externalClipboardWrite);
    }
    try {
        const clipboardItem = new ClipboardItem({
            'text/plain': new Blob([clipboardData.plainText], { type: 'text/plain' }),
            'text/html': new Blob([clipboardData.htmlText], { type: 'text/html' })
        });
        await navigator.clipboard.write([clipboardItem]);
        return true;
    }
    catch {
        return writeToClipboardLegacy(clipboardData);
    }
}
async function writeToClipboardExternal(clipboardData, externalClipboardWrite) {
    async function failAfterTwoSeconds() {
        await new Promise((resolve) => setTimeout(resolve, 2000));
        return false;
    }
    try {
        const success = await Promise.race([
            externalClipboardWrite(clipboardData),
            failAfterTwoSeconds()
        ]);
        return success;
    }
    catch (e) {
        console.error(e);
        return false;
    }
}
function writeToClipboardLegacy(clipboardData) {
    function onCopy(event) {
        var _a, _b;
        (_a = event.clipboardData) === null || _a === void 0 ? void 0 : _a.setData('text/plain', clipboardData.plainText);
        (_b = event.clipboardData) === null || _b === void 0 ? void 0 : _b.setData('text/html', clipboardData.htmlText);
        event.preventDefault();
    }
    try {
        document.addEventListener('copy', onCopy);
        document.execCommand('copy');
        document.removeEventListener('copy', onCopy);
        return true;
    }
    catch (e) {
        console.error(e);
        return false;
    }
}
